(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["teaser"] && !window.DesignMode) return;
  try {
    
  function init() {
    const containerHeight = document.querySelector('.teaser__content').scrollHeight;
    const content = document.querySelector('.teaser__content');

    content.scrollTop = content.scrollHeight;
    content.classList.add('teaser__content--ready');

    content.addEventListener('scroll', onScroll);
    onScroll();
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);

  function onScroll() {
    const content = document.querySelector('.teaser__content');

    const maxScroll = content.scrollHeight - content.clientHeight;
    const shadow = mapRange(content.scrollTop, 0, maxScroll, 25, window.innerHeight / 2);
    content.style.setProperty('--shadow', `${shadow}px`);
  }

  function mapRange(current, in_min, in_max, out_min, out_max) {
    const mapped = ((current - in_min) * (out_max - out_min)) / (in_max - in_min) + out_min;
    return clamp(mapped, out_min, out_max);
  }

  function clamp(input, min, max) {
    return input < min ? min : input > max ? max : input;
  }

  } catch(e) { console.error(e); }
})();
})();
